;(function () {
	const initProductAccordion = () => {
		const aboutToggleItems = $('.about__accordion-toggle')

		aboutToggleItems.each(function () {
			const currentToggle = $(this)
			const siblingToggles = currentToggle.siblings(
				'.about__accordion-description'
			)

			currentToggle.click(function () {
				if (!currentToggle.hasClass('active')) {
					aboutToggleItems.each(function () {
						const siblingToggle = $(this)
						siblingToggle.removeClass('active')
						siblingToggle
							.siblings('.about__accordion-description')
							.stop()
							.slideUp(300)
					})

					currentToggle.addClass('active')

					siblingToggles.stop().slideDown(300)
				} else {
					currentToggle.removeClass('active')
					siblingToggles.stop().slideUp(300)
				}
			})
		})
	}

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			'.product-media-modal__content'
		)
		const images = imagesWrapper?.querySelectorAll('.js-image-zoom') || []

		images.forEach((el) => {
			el.addEventListener('click', (e) => {
				imagesWrapper.classList.toggle('zoom')
			})
		})
	}

	const formatFreeShippingAmount = (value) => {
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
		const formatString = theme.moneyFormat

		return formatString.replace(placeholderRegex, value)
	}

	const setTotalFreeShipping = () => {
		if (document.querySelector('.js-free-shipping')) {
			const freeShippingTotal = document.querySelector('.free-shipping-total')
			if (freeShippingTotal) {
				const minSpend = Number(freeShippingTotal.dataset.minSpend)
				if (minSpend && minSpend > 0) {
					freeShippingTotal.innerText = `${formatFreeShippingAmount(
						Math.round(minSpend * (Shopify.currency.rate || 1))
					)}`
				}
			}
		}
	}
	function changeIconsViewBox() {
		const textWithIcon = document.querySelectorAll('.text_with_icon')
		textWithIcon.forEach((item) => {
			const icons = item.querySelectorAll('.icon-pack')
			icons.forEach((icon) => {
				icon.setAttribute('viewBox', '0 0 20 20')
			})
		})
	}

	//document.addEventListener('scroll', () => {
	//	const navigation = document.querySelector('.product__media_navigation')
	//	if (navigation) {
	//		const footer = document.querySelector('.footer')
	//		const navigationHeight = navigation.offsetHeight
	//		const screen = window.scrollY
	//		const overview = document.querySelector('#overview').scrollTop
	//		const overviewBottom =
	//			document.querySelector('#overview').clientHeight + overview
	//		if (screen >= overview && screen <= overviewBottom) {
	//			document.querySelector('#overview-link').classList.add('active')
	//		} else {
	//			document.querySelector('#overview-link').classList.remove('active')
	//		}
	//		if (window.innerHeight + screen - navigationHeight > footer.offsetTop) {
	//			navigation.style.opacity = '0'
	//			navigation.style.visibility = 'hidden'
	//		} else {
	//			navigation.style.opacity = '1'
	//			navigation.style.visibility = 'visible'
	//		}
	//	}
	//})

	const navigationSections = [
		{
			sectionSelector: '#overview',
			linkSelector: '#overview-link',
		},
		{
			sectionSelector: '#product-specifications',
			linkSelector: '#specifications-link',
		},
	]

	function navigationInit(sections) {
		const navigation = document.querySelector('.product__media_navigation')
		if (navigation) {
			navigation.style.transform = 'translateX(-50%) translateY(calc(100% + 16px))'
		}
		document.addEventListener('scroll', () => {
			if (navigation) {
				navigation.classList.add('show-navigation')
			}
			if (navigation) {
				const footer = document.querySelector('.footer')
				const navigationHeight = navigation.offsetHeight
				const secondSection = document.querySelectorAll('#MainContent .shopify-section')[1]
				const screen = window.scrollY
				sections.forEach((section) => {
					if (!section) return

					const em = document.querySelector(section.sectionSelector)
					const link = document.querySelector(section.linkSelector)
					if (!link) return

					if (em) {
						const rect = em.getBoundingClientRect()
						if (rect.top <= 1 && rect.top > rect.height * -1) {
							link.classList.add('active')
						} else {
							link.classList.remove('active')
						}
						link.addEventListener('click', () => {
							em.scrollIntoView({ behavior: 'smooth' })
						})
					} else {
						link.style.display = 'none'
					}
				})

				const isSecondSectionScrolled = secondSection
					? secondSection.getBoundingClientRect().top < 0
					: false
				const isNearFooter = footer
					? window.innerHeight + screen - navigationHeight > footer.offsetTop
					: false

				navigation.style.transform = isSecondSectionScrolled && !isNearFooter
				? 'translateX(-50%) translateY(0)'
				: 'translateX(-50%) translateY(calc(100% + 16px))';
			}
		})
	}

	const ensurePromoIframeLoaded = (iframe) => {
		const src = iframe?.dataset?.src
		if (!src) return Promise.resolve()

		if (iframe.getAttribute('src') === src) return Promise.resolve()

		return new Promise((resolve) => {
			iframe.addEventListener('load', () => resolve(), { once: true })
			iframe.setAttribute('src', src)
		})
	}

	const unloadPromoIframe = (iframe) => {
		if (!iframe) return

		if (iframe.classList.contains('js-youtube') && iframe.contentWindow) {
			iframe.contentWindow.postMessage(
				'{"event":"command","func":"pauseVideo","args":""}',
				'*'
			)
		}

		if (iframe.classList.contains('js-vimeo') && iframe.contentWindow) {
			iframe.contentWindow.postMessage('{"method":"pause"}', '*')
		}

		iframe.removeAttribute('src')
	}

	const playPromoModalMedia = async (modal) => {
		const nativeVideo = modal.querySelector('.product-promo-banner-modal__video')
		if (nativeVideo) {
			nativeVideo.currentTime = 0
			nativeVideo.play().catch(() => {})
			return
		}

		const youtube = modal.querySelector('.js-youtube')
		const vimeo = modal.querySelector('.js-vimeo')
		const iframe = youtube || vimeo

		if (!iframe) return

		await ensurePromoIframeLoaded(iframe)

		setTimeout(() => {
			if (youtube?.contentWindow) {
				youtube.contentWindow.postMessage(
					'{"event":"command","func":"playVideo","args":""}',
					'*'
				)
			}

			if (vimeo?.contentWindow) {
				vimeo.contentWindow.postMessage('{"method":"play"}', '*')
			}
		}, 150)
	}

	const stopPromoModalMedia = (modal) => {
		const nativeVideo = modal.querySelector('.product-promo-banner-modal__video')
		if (nativeVideo) {
			nativeVideo.pause()
			nativeVideo.currentTime = 0
			return
		}

		unloadPromoIframe(modal.querySelector('.js-youtube'))
		unloadPromoIframe(modal.querySelector('.js-vimeo'))
	}

	const getStickyAtcSection = () => {
		const el = document.querySelector('.shopify-section--sticky-atc')
		if (!el?.id?.startsWith('shopify-section-')) return null

		return {
			el,
			id: el.id.replace('shopify-section-', ''),
		}
	}

	const buildSectionFetchUrl = (baseUrl, sectionId) => {
		const separator = baseUrl.includes('?') ? '&' : '?'
		return `${baseUrl}${separator}section_id=${encodeURIComponent(sectionId)}`
	}

	const fetchSectionHtml = async (url, sectionId) => {
		const response = await fetch(buildSectionFetchUrl(url, sectionId))
		if (!response.ok) throw new Error(`Section fetch failed: ${sectionId}`)

		const html = new DOMParser().parseFromString(await response.text(), 'text/html')
		const section = html.getElementById(`shopify-section-${sectionId}`)
		if (!section) throw new Error(`Section markup missing: ${sectionId}`)

		return { html, section }
	}

	const replaceShopifySection = (targetEl, sourceSection, runScripts = false) => {
		targetEl.innerHTML = sourceSection.innerHTML

		if (!runScripts) return

		targetEl.querySelectorAll('script').forEach((script) => {
			const replacement = document.createElement('script')
			Array.from(script.attributes).forEach((attr) => {
				replacement.setAttribute(attr.name, attr.value)
			})
			replacement.textContent = script.textContent
			script.replaceWith(replacement)
		})
	}

	const swapProductSections = async (url, mainSectionId) => {
		const mainSectionEl = document.getElementById(`shopify-section-${mainSectionId}`)
		if (!mainSectionEl) throw new Error('Main product section missing')

		const stickySection = getStickyAtcSection()
		const requests = [fetchSectionHtml(url, mainSectionId)]

		if (stickySection) {
			requests.push(fetchSectionHtml(url, stickySection.id))
		}

		const [mainResult, stickyResult] = await Promise.all(requests)

		replaceShopifySection(mainSectionEl, mainResult.section, false)

		if (stickySection && stickyResult) {
			replaceShopifySection(stickySection.el, stickyResult.section, true)
			stickySection.el.dispatchEvent(
				new CustomEvent('shopify:section:load', { bubbles: true })
			)
		}

		const pageTitle = mainResult.html.querySelector('title')?.textContent
		if (pageTitle) document.title = pageTitle

		return mainSectionEl
	}

	const initProductSwitch = () => {
		document.querySelectorAll('[data-product-switch]').forEach((switcher) => {
			if (switcher.dataset.productSwitchInit === 'true') return
			switcher.dataset.productSwitchInit = 'true'

			const sectionId = switcher.dataset.sectionId
			if (!sectionId) return

			switcher.addEventListener('click', async (event) => {
				const link = event.target.closest('[data-product-switch-link]')
				if (!link) return

				event.preventDefault()

				const url = link.getAttribute('href')
				if (!url) return

				const sectionEl = document.getElementById(`shopify-section-${sectionId}`)
				if (!sectionEl) {
					window.location.href = url
					return
				}

				switcher.classList.add('is-loading')
				link.setAttribute('aria-busy', 'true')

				try {
					const updatedSectionEl = await swapProductSections(url, sectionId)

					history.pushState({ productSwitch: true }, '', url)

					document.dispatchEvent(new CustomEvent('shopify:section:load'))
					updatedSectionEl.dispatchEvent(
						new CustomEvent('shopify:section:load', { bubbles: true })
					)

					initProductSwitch()

					const scrollTarget =
						document.getElementById(`MainProduct-${sectionId}`) || updatedSectionEl
					window.scrollTo({
						top: Math.max(scrollTarget.getBoundingClientRect().top + window.scrollY - 80, 0),
						behavior: 'smooth',
					})
				} catch (error) {
					console.error(error)
					window.location.href = url
				} finally {
					switcher.classList.remove('is-loading')
					link.removeAttribute('aria-busy')
				}
			})
		})
	}

	if (!window.__productSwitchPopstateInit) {
		window.__productSwitchPopstateInit = true

		window.addEventListener('popstate', async () => {
			const switcher = document.querySelector('[data-product-switch]')
			const sectionId = switcher?.dataset.sectionId
			const sectionEl = sectionId
				? document.getElementById(`shopify-section-${sectionId}`)
				: null

			if (!sectionId || !sectionEl) return

			try {
				const updatedSectionEl = await swapProductSections(window.location.pathname, sectionId)

				document.dispatchEvent(new CustomEvent('shopify:section:load'))
				updatedSectionEl.dispatchEvent(
					new CustomEvent('shopify:section:load', { bubbles: true })
				)
				initProductSwitch()
			} catch (error) {
				window.location.reload()
			}
		})
	}

	const initPromoBannerModalVideos = () => {
		document
			.querySelectorAll('modal-dialog.product-promo-banner-modal')
			.forEach((modal) => {
				if (modal.dataset.promoVideoInit) return
				modal.dataset.promoVideoInit = 'true'

				const observer = new MutationObserver(() => {
					if (modal.hasAttribute('open')) {
						playPromoModalMedia(modal)
					} else {
						stopPromoModalMedia(modal)
					}
				})

				observer.observe(modal, {
					attributes: true,
					attributeFilter: ['open'],
				})
			})
	}

	document.addEventListener('shopify:section:load', function () {
		initProductAccordion()
		initZoomImage()
		setTotalFreeShipping()
		changeIconsViewBox()
		navigationInit(navigationSections)
		initPromoBannerModalVideos()
		initProductSwitch()
	})

	navigationInit(navigationSections)
	initProductAccordion()
	initZoomImage()
	setTotalFreeShipping()
	changeIconsViewBox()
	initPromoBannerModalVideos()
	initProductSwitch()
})()
